<template>
<div id="user-profile">

    <div id="showPhoto">
              <v-layout row justify-center>
    <v-dialog v-model="showPict" persistent max-width="670">
      <v-card>
        <v-card-title class="headline">Photo de {{this.firstName}}</v-card-title>
        <v-card-text><img v-bind:src="signinUser.imageUrl"/></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat @click.native="showPict = false">Fermer</v-btn>
          <v-btn color="green darken-1" flat @click.native="takePhoto">Changer la photo</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
          </div>

   <v-container fluid grid-list-xl>
    <v-layout wrap align-center>
      <v-flex xs12 sm6 offset-sm3>
  <v-toolbar>
    <v-toolbar-title>
        <v-avatar>
      <img v-on:click="showPict = true" style="cursor: pointer" v-bind:src="signinUser.imageUrl"/>
    </v-avatar>
      <span>{{signinUser.firstName}} {{signinUser.lastName}}</span><br>
        
    </v-toolbar-title>   
  </v-toolbar>
  <v-card class="mb-5">
       <v-card-title>
    <form @submit.prevent="saveEmployee">
      <v-layout row wrap>
      <br>
           <v-flex xs12 sm6>
              <v-text-field 
                label= "First Name"
                name="firstName" 
                autocomplete="given-name"
                @input="profileChanged = true"
                v-model="signinUser.firstName"
                :disabled="sending">
              </v-text-field>
           </v-flex>

           <v-flex xs12 sm6>
              <v-text-field
                label="Last Name"
                autocomplete="family-name"
                v-model="signinUser.lastName"
                @input="profileChanged = true"
                :disabled="sending">
              </v-text-field>
           </v-flex>
           <v-flex xs12 sm6>
            <v-text-field
            label="Telephone"
            v-model="signinUser.phone"
            @input="profileChanged = true"
            required>
          </v-text-field>
           </v-flex>
           <v-flex xs12 sm6>
            <v-text-field
            :disabled="clerk"
            label="Email"
            type="email"
            autocomplete="email"
            @input="profileChanged = true"
            v-model="signinUser.email">
          </v-text-field>
          </v-flex>
           <v-flex xs12 sm4>
            <v-autocomplete v-model="signinUser.city" label="city" id="city" :items="areas" required>
              </v-autocomplete>
          </v-flex>
          <v-flex xs12 sm4>           
            <v-autocomplete v-model="signinUser.postalCode" label="Quartier" :items="zones" required>
              </v-autocomplete>
          </v-flex>
           <v-flex xs12 sm4>
            <v-text-field
            type="text"
            label="Avenue et numero"
            v-model="signinUser.address"
            required
            >
          </v-text-field>
            </v-flex>
     
           <v-flex xs12 sm6>
        <span class="md-title">Niveau d'accès:</span>
        <v-select
        :disabled="clerk"
        solo
        v-model="signinUser.accessLevel"
        required
        :items="['Clerk','Admin', 'Super Admin']"
        >
        </v-select>
          </v-flex>
           <v-flex xs12 sm6>
            <v-text-field
            label="Numero d'employé"
            v-model="signinUser.employeeNumber" readonly>
          </v-text-field>
          </v-flex>
          
          
          <v-flex xs12 sm6>
               <v-text-field
            v-model="newPassword"
            :append-icon="show1 ? 'visibility_off' : 'visibility'"
            :rules="[rules.min]"
            :type="show1 ? 'text' : 'password'"
            name="input-10-2"
            label="Mot de passe"
            hint="Au moins 8 charactères"
            @input="profileChanged = true"
            @click:append="show1 = !show1"
          ></v-text-field>
          </v-flex>
            <v-flex xs12 sm6>
            <v-text-field
            v-model="confirmPassword"
            :append-icon="show2 ? 'visibility_off' : 'visibility'"
            :rules="[rules.passwordMatch]"
            :type="show2 ? 'text' : 'password'"
            name="input-10-2"
            label="Confirmer le mot de passe"
            @click:append="show2 = !show2"
          ></v-text-field>
          </v-flex>
        <v-card-actions>
           <v-btn v-on:click="goBack" color="primary">Retour</v-btn>
        </v-card-actions>
            <v-spacer></v-spacer>
        <v-card-actions>
          <v-btn type="submit" color="primary">Modfier</v-btn>
        </v-card-actions>
       
      </v-layout>
    </form>
       </v-card-title>
  </v-card>
      </v-flex>
    </v-layout>
   </v-container>
  </div>
</template>
<script>
/* eslint-disable */
import { db } from '@/api/firebaseInit';
import firebase from 'firebase';
import { communes } from '@/api/communes';
import { quartiers } from '@/api/quartiers';
export default {
  name: 'user-profile',
  data() {
    return {
      accessLevel: null,
      editMode: true,
      showData: false,
      selected: {},
      search: null,
      zones: quartiers,
      areas: communes,
      searched: [],
      address: null,
      city: null,
      postalCode: null,
      employee_id: null,
      employeeNumber: null,
      sending: false,
      access: 'Clerk',
      phone: null,
      email: null,
      imageUrl: '/assets/avatar.png',
      showPict: false,
      firstName: null,
      menu: false,
      profileChanged: false,
      newPassword: '',
      confirmPassword: '',
      lastName: null,
      entriesDate: null,
      fullName: null,
      show1: false,
      show2: false,
      rules: {
        required: value => !!value || 'Obligatoire.',
        min: v => v.length >= 8 || 'Min 8 charactères',
        passwordMatch: value =>
          value == this.newPassword || 'Les mots de passe ne correspondent pas'
      }
    };
  },
  computed: {
    signinUser() {
      return this.$store.getters.signinUser;
    },
    clerk () {
      console.log(this.signinUser.accessLevel)
      if (this.signinUser.accessLevel == "Clerk") {
        return true
      } else {
        return false
      }
    }
    // entriesDate: function () {
    //      var today = (new Date()).toString();
    //      today = today.substring(0, 15);
    // }
  },
  methods: {
   
    fetchLoginData() {
      db.collection('Employees')
        .doc(this.employee_id)
        .collection('Logs')
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            const data = {
              id: doc.id,
              loginTime: doc.data().loginTime,
              logOutTime: doc.data().logOutTime
            };
            this.members.push(data);
            this.searched = this.members;
          });
        });
    },
    fetchDataEntries() {
      this.members = [];
      db.collection('Employees')
        .doc(this.employee_id)
        .collection('Entries')
        .doc('currentDate')
        .collection('Entries')
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
          });
        });
    },
    save(date) {
      this.$refs.menu.save(date);
    },
    saveEmployee() {
      this.employee_id = this.signinUser.id
      var that = this;
      var googPhone = '+' + this.phone;
      if (this.profileChanged) {
        this.fullName = this.firstName + ' ' + this.lastName;
        db.collection('Employees')
          .doc(this.employee_id)
          .collection('Profile')
          .doc(this.employee_id)
          .set({
            displayName: this.fullName,
            email: this.email,
            newPassword: this.newPassword,
            phone: googPhone
          })
          .then(function() {
            that.profileChanged = false;
            that.updateEmployee();
          });
      } else {
        this.updateEmployee();
      }
    },
    updateEmployee() {
      db.collection('Employees')
        .doc(this.employee_id)
        .update({
          address: this.address,
          city: this.city,
          postalCode: this.postalCode,
          employeeId: this.employee_id,
          email: this.email,
          accessLevel: this.accessLevel,
          firstName: this.firstName,
          phone: this.phone,
          lastName: this.lastName
        })
        .then(function(docRef) {
          alert(`Votre profile a été modifié`);
          //   that.goBack()
        })
        .catch(function(error) {
          console.error('Error adding document: ', error);
        });
    },
    validateUser() {
      this.saveEmployee();
    },
    getValidationClass(fieldName) {
      const field = this.$v[fieldName];

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        };
      }
    },
    goBack() {
      this.$router.push('/');
    },
    takePhoto() {
      this.$router.push({
        name: 'take-photo',
        params: {
          employee_id: this.employee_id
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/Profile.vue